export default __webpack_public_path__ + "static/media/logo-letras.0a67738e.svg";